import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  Input,
  Output,
  EventEmitter
} from '@angular/core';
import { SuraOptionItemComponent, OptionItemConfig } from '../../molecules/data/option-item/option-item.component';

export interface OptionListSection {
  title: string;
  items: OptionItemConfig[];
}

export interface OptionListConfig {
  items?: OptionItemConfig[];
  sections?: OptionListSection[];
  selectable?: boolean;
  multiSelect?: boolean;
  maxHeight?: string;
  collapsed?: boolean;
}
/**
 * Componente OptionList simplificado - Solo UI, sin arquitectura hexagonal
 */
@Component({
  selector: 'sura-option-list',
  standalone: true,
  imports: [CommonModule, SuraOptionItemComponent],
  template: `
    <div [class]="containerClasses" [style.max-height]="config.maxHeight">
      @if (config.sections && config.sections.length > 0) {
        @for (section of config.sections; track section.title; let i = $index) {
          @if (i > 0) {
            <div class="h-px bg-gray-200 dark:bg-gray-700 my-1 mx-3"></div>
          }
          @if (!config.collapsed) {
            <div class="px-4 pt-4 pb-1">
              <span class="text-xs font-semibold uppercase tracking-wider text-sura-gray-800 dark:text-gray-400">
                {{ section.title }}
              </span>
            </div>
          }
          @for (item of section.items; track item.id) {
            <sura-option-item
              [config]="item"
              (itemClick)="onItemClick($event)">
            </sura-option-item>
          }
        }
      } @else if (config.items) {
        @for (item of config.items; track item.id) {
          <sura-option-item 
            [config]="item"
            (itemClick)="onItemClick($event)">
          </sura-option-item>
        }
      }
    </div>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush
})

export class SuraOptionListComponent {
  
  @Input({ required: true }) config!: OptionListConfig;
  @Output() itemClick = new EventEmitter<OptionItemConfig>();
  @Output() selectionChange = new EventEmitter<OptionItemConfig[]>();

  get containerClasses(): string {
    const classes = ['flex', 'flex-col', 'gap-1'];
    
    if (this.config.maxHeight) {
      classes.push('overflow-y-auto');
    }
    
    return classes.join(' ');
  }

  expandedItems = new Set<string>();

  toggleExpand(item: OptionItemConfig) {
    if (this.expandedItems.has(item.id)) {
      this.expandedItems.delete(item.id);
    } else {
      this.expandedItems.add(item.id);
    }
  }

  isExpanded(item: OptionItemConfig, index?: number): boolean {
    // "Girop" nunca colapsa, siempre expandido
    if (item.title === 'Girop') {
      return true;
    }
    return this.expandedItems.has(item.id);
  }

  onItemClick(item: OptionItemConfig): void {
    this.itemClick.emit(item);
    if (this.config.selectable) {
      this.selectionChange.emit([item]);
    }
  }
}